import { Textarea, TextareaProps } from '@conexasaude/conexa-hero'
import { ReactElement, TextareaHTMLAttributes } from 'react'
import { Controller, Control, Path } from 'react-hook-form'

export interface ConexaTextAreaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement>,
    TextareaProps {}

type TextAreaControlType<T> = ConexaTextAreaProps & {
  name: Path<T>
  control?: Control<T>
}

function TextareaControl<T>({
  name,
  control,
  onChange: onInputChange,
  autosize = false,
  ...rest
}: TextAreaControlType<T>): ReactElement {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange } }) => {
        return (
          <Textarea
            onChange={event => {
              onChange(event)
              if (onInputChange) onInputChange(event)
            }}
            value={value as string}
            autosize={autosize}
            {...rest}
          />
        )
      }}
    />
  )
}

export default TextareaControl
